import {
	type TimelineEventType,
	OBJECT_UPDATE_EVENT,
	OBJECT_COMMENT_EVENT,
} from '../../common/types/timeline-event.tsx';
import {
	OBJECT_ACTIVITY_TYPE_COMMENT,
	OBJECT_ACTIVITY_TYPE_HISTORY,
	type ObjectActivityType,
} from '../../services/object-activity/types.tsx';

export const getServiceEventNameByStoreEvent = (
	storeEvent: TimelineEventType,
): ObjectActivityType | undefined => {
	switch (storeEvent) {
		case OBJECT_COMMENT_EVENT:
			return OBJECT_ACTIVITY_TYPE_COMMENT;
		case OBJECT_UPDATE_EVENT:
			return OBJECT_ACTIVITY_TYPE_HISTORY;
		default:
			return undefined;
	}
};
